export default () => {
  return [
    { id: 1, title: 'Text message', text: '', key: 'sms' },
    { id: 2, title: 'Email', text: '', key: 'email' }
  ]
}
